/**
 * Element / question-category display-name overrides.
 *
 * Single source of truth for the UI-only renames applied to canonical element
 * and question-category names. Mirrors the API map at
 * `src/brand-equity/element-display-names.ts` (kept in sync by convention —
 * no shared package between repos).
 *
 * Why this lives in `utils/`: the rename is a global presentation concern
 * imported by admin pages, brand-equity views, question templates, surveys,
 * dashboards and the marketer view. Keeping it in a feature folder caused
 * cross-domain imports.
 */

export const ELEMENT_DISPLAY_NAMES: Readonly<Record<string, string>> = Object.freeze({
  'Distribution Intensity': 'Availability',
  'Standardised NPS': 'Advocacy Intent',
  'Alignment Depth': 'Touchpoints',
});

/**
 * Translate a canonical element/QC name to its marketer-facing display name.
 * Returns the input unchanged if no override exists.
 */
export const getDisplayName = (name: string): string =>
  ELEMENT_DISPLAY_NAMES[name] ?? name;
